import React from 'react';
export function About() {
  return <section id="about" className="py-20 bg-white" data-id="element-14">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl text-center" data-id="element-15">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-navy mb-6" data-id="element-16">
          À propos de AVENIR 2000
        </h2>
        <div className="w-24 h-1 bg-brand-gold mx-auto rounded-full mb-8" data-id="element-17"></div>
        <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-18">
          AVENIR 2000 est votre partenaire de confiance pour l'approvisionnement
          en gros et au détail. Forts de notre expérience, nous nous engageons à
          fournir à nos clients une sélection rigoureuse de produits dans les
          domaines de l'alimentation, des boissons, de la maison et de
          l'électronique.
        </p>
        <p className="text-lg text-gray-600 leading-relaxed" data-id="element-19">
          Notre mission est simple : vous offrir{' '}
          <strong className="text-brand-navy font-semibold" data-id="element-20">
            le choix, la qualité, au meilleur prix
          </strong>
          . Nous travaillons en étroite collaboration avec nos fournisseurs pour
          garantir la fraîcheur, la durabilité et la performance de chaque
          article que nous proposons.
        </p>
      </div>
    </section>;
}